import type { LocationAddress } from "@sitescene/types";

export const toSpaces = (str: string) => str.replace(/[_-]/g, " ");

export const toTitleCase = (str: string) => {
	return toSpaces(str).replace(/\b\w/g, (char) => char.toUpperCase());
};

// Helper function to format address for display
export const formatAddress = (address?: LocationAddress): string => {
	if (!address) return "No address";
	const parts: string[] = [];
	if (address.street1) parts.push(address.street1);
	if (address.city) parts.push(address.city);
	if (address.stateProvince) parts.push(address.stateProvince);
	if (address.postalCode) parts.push(address.postalCode);
	if (address.country) parts.push(address.country);
	return parts.length > 0 ? parts.join(", ") : "No address";
};
